/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class, no-nested-ternary */
import { FC, useState } from 'react';
import { Icon } from 'learning-panel-components';
import { badges as badgesMapping } from 'utils';
import styles from './achievementsCollapsed.module.scss';

const AchievementsCollapsed: FC<AchievementsCollapsedProps> = (props: AchievementsCollapsedProps) => {
    const { onExpand, userCoins, userBadges } = props;
    const [isHovered, setIsHovered] = useState<boolean>(false);

    return (
        <div
            className={styles['achievements-unexpand']}
            onMouseOver={(): void => setIsHovered(true)}
            onMouseLeave={(): void => setIsHovered(false)}
            onClick={() => onExpand(true)}
        >
            {isHovered && <Icon data-testid="arrow-icon" name={'upDownExpand'} />}
            <Icon data-testid="dev-coins" name="devCoin" className={styles['dev-coin']} />
            <div className={styles.text}>{userCoins.toLocaleString()}</div>
            {userBadges.length > 0 && (
                <div className={styles['coins-wrapper']}>
                    <hr />
                    <Icon name={badgesMapping[userBadges[0]].earnIconName} isPng className={styles['icon-wrapper']} />
                    {userBadges.length === 1 && <div className={styles.text}> +{userBadges.length + 1} </div>}
                </div>
            )}
        </div>
    );
};

interface AchievementsCollapsedProps {
    isLoading: boolean;
    userCoins: number;
    userBadges: string[];
    onExpand: Function;
}

export default AchievementsCollapsed;
